module.exports = __webpack_public_path__ + "img/show_labels_White_24dp.a080697a.svg";